import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@shared/ui/sidebar";
import { Link } from "@tanstack/react-router";
import { Folders, LayoutDashboard } from "lucide-react";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
	dashboard: {
		id: "page.dashboard.title",
		defaultMessage: "Dashboard",
	},
	storage: {
		id: "page.storage.title",
		defaultMessage: "Storage",
	},
});

const navItems = [
	{
		message: messages.dashboard,
		url: "/",
		icon: LayoutDashboard,
	},
	{
		message: messages.storage,
		url: "/storage",
		icon: Folders,
	},
];

export function NavMain() {
	const intl = useIntl();

	return (
		<SidebarGroup>
			<SidebarGroupContent className="flex flex-col gap-4">
				<SidebarMenu className="space-y-1">
					{navItems.map((item) => (
						<SidebarMenuItem key={item.message.id}>
							<Link to={item.url}>
								{({ isActive }) => (
									<SidebarMenuButton
										tooltip={intl.formatMessage(item.message)}
										className="cursor-pointer"
										isActive={isActive}
									>
										{item.icon && <item.icon />}
										<span>{intl.formatMessage(item.message)}</span>
									</SidebarMenuButton>
								)}
							</Link>
						</SidebarMenuItem>
					))}
				</SidebarMenu>
			</SidebarGroupContent>
		</SidebarGroup>
	);
}
